var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcAuthFb(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icFacebookCircle") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Main-screens-Stage-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Verify-your-Account",
    transform: "translate(-305.000000, -15.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(0.000000, 15.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icFacebookCircle",
    transform: "translate(305.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#3B5998",
    cx: 24.8221239,
    cy: 24.8221239,
    r: 24.8221239
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0623894,25.7938053 L26.6331858,25.7938053 L26.6331858,42.020354 L19.9225664,42.020354 L19.9225664,25.7938053 L16.7309735,25.7938053 L16.7309735,20.0911504 L19.9225664,20.0911504 L19.9225664,16.400885 C19.9225664,13.7619469 21.1761062,9.62964602 26.6929204,9.62964602 L31.6637168,9.65044248 L31.6637168,15.1858407 L28.0570796,15.1858407 C27.4654867,15.1858407 26.6336283,15.4814159 26.6336283,16.7402655 L26.6336283,20.0964602 L31.6486726,20.0964602 L31.0623894,25.7938053 Z",
    id: "Path",
    fill: "#FFFFFF"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAuthFb);
export default __webpack_public_path__ + "static/media/icAuthFb.7282711577a2d118a4ddd60d84f82c96.svg";
export { ForwardRef as ReactComponent };